module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Tipo de acréscimo",
      "columns": 2
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionType),
      expression: "additionType"
    }],
    staticClass: "form-input",
    attrs: {
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.additionType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.additionType = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Valor do acréscimo",
      "columns": 2
    }
  }, [_c('div', {
    staticClass: "form-flex"
  }, [(_vm.item.additionType === 'fixed') ? _c('money', _vm._b({
    staticClass: "form-input",
    attrs: {
      "readonly": "readonly"
    },
    model: {
      value: (_vm.item.additionValue),
      callback: function($$v) {
        _vm.$set(_vm.item, "additionValue", $$v)
      },
      expression: "item.additionValue"
    }
  }, 'money', _vm.money, false)) : _vm._e(), _vm._v(" "), (_vm.item.additionType === 'percent') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.additionValue),
      expression: "item.additionValue"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.item.additionValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "additionValue", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.item.additionType === 'percent') ? _c('span', {
    staticClass: "form-addon"
  }, [_vm._v("%")]) : _vm._e()], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "De",
      "columns": 2
    }
  }, [_c('money', _vm._b({
    staticClass: "form-input",
    attrs: {
      "readonly": "readonly"
    },
    model: {
      value: (_vm.item.from.minRange),
      callback: function($$v) {
        _vm.$set(_vm.item.from, "minRange", $$v)
      },
      expression: "item.from.minRange"
    }
  }, 'money', _vm.money, false))], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Até",
      "columns": 2
    }
  }, [_c('money', _vm._b({
    staticClass: "form-input",
    attrs: {
      "readonly": "readonly"
    },
    model: {
      value: (_vm.item.to.maxRange),
      callback: function($$v) {
        _vm.$set(_vm.item.to, "maxRange", $$v)
      },
      expression: "item.to.maxRange"
    }
  }, 'money', _vm.money, false))], 1), _vm._v(" "), _c('div', {
    staticClass: "l-col-2@md vertical-center"
  }, [_vm._t("default")], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-col-1@md vertical-center"
  }, [_c('i', {
    staticClass: "i-arrow icon-arrow-right center"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e669ea1e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/presets/ecommerce/moovin/marketplace/skyhub/AdditionItem.vue
// module id = 3467
// module chunks = 0